import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { Star, Mountain } from "lucide-react";
import { toast } from "sonner";

export default function Survey() {
  const { rentalId } = useParams();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);
  const [biz, setBiz] = useState("RentalPro");

  useEffect(() => {
    // public endpoint - no auth
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`).then(r => r.json()).then(s => setBiz(s.business_name));
  }, []);

  const submit = async () => {
    if (rating === 0) return toast.error("Beri rating dulu");
    try {
      await api.post("/survey", { rental_id: rentalId, rating, comment });
      setDone(true);
    } catch { toast.error("Gagal kirim"); }
  };

  if (done) return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-neutral-50">
      <Card className="max-w-md w-full border-neutral-200 shadow-none">
        <CardContent className="p-8 text-center">
          <div className="w-14 h-14 rounded-full mx-auto flex items-center justify-center" style={{background: "var(--brand-primary)"}}>
            <Star className="w-7 h-7 text-white fill-white" />
          </div>
          <h2 className="font-display text-2xl font-bold mt-4">Terima kasih!</h2>
          <p className="text-neutral-600 mt-2">Masukan Anda sangat berarti untuk peningkatan layanan {biz}.</p>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-neutral-50">
      <Card className="max-w-md w-full border-neutral-200 shadow-none">
        <CardContent className="p-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded flex items-center justify-center" style={{background: "var(--brand-primary)"}}>
              <Mountain className="w-6 h-6 text-white" />
            </div>
            <div className="font-display font-bold text-lg">{biz}</div>
          </div>
          <h2 className="font-display text-2xl font-bold mt-6">Bagaimana pengalaman Anda?</h2>
          <p className="text-sm text-neutral-500 mt-1">Nilai pengalaman sewa Anda 1-5 bintang.</p>
          <div className="flex gap-2 mt-6 justify-center">
            {[1,2,3,4,5].map(n => (
              <button key={n} data-testid={`star-${n}`} onClick={() => setRating(n)} className="p-1">
                <Star className={`w-9 h-9 ${n <= rating ? "fill-red-600 text-red-600" : "text-neutral-300"}`} strokeWidth={1.5} />
              </button>
            ))}
          </div>
          <Textarea placeholder="Saran & masukan (opsional)..." value={comment} onChange={e => setComment(e.target.value)} className="mt-6" rows={4} />
          <Button data-testid="survey-submit" onClick={submit} className="w-full mt-4 text-white h-11" style={{background: "var(--brand-primary)"}}>Kirim</Button>
        </CardContent>
      </Card>
    </div>
  );
}
